'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getBrowserLanguage = require('./getBrowserLanguage');

var _getBrowserLanguage2 = _interopRequireDefault(_getBrowserLanguage);

var _getValidLangKey = require('./getValidLangKey');

var _getValidLangKey2 = _interopRequireDefault(_getValidLangKey);

var _ramda = require('ramda');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get user browser valid langKey
 * @param {[String]} langs allowed lang keys ['en', 'fr', 'pt']
 * @param {String} defaultLangKey default browser language key
 * @return {string} valid langKey
 */
var getUserLangKey = function getUserLangKey(langs, defaultLangKey) {
  return (0, _ramda.pipe)(_getBrowserLanguage2.default, (0, _getValidLangKey2.default)(langs, defaultLangKey))();
};

exports.default = getUserLangKey;


//////////////////
// WEBPACK FOOTER
// ./~/ptz-i18n/dist/getUserLangKey.js
// module id = 110
// module chunks = 34471704633725 35783957827783 114276838955818 216468464745311